<template>
  <v-container fluid align-start ma-0 pa-2 class="epmsa250-main container-height">
    <v-row no-gutters>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle" >
          <template v-slot:body>
            <v-row no-gutters>
              <v-col>
                <i-card-top
                  class="d-md-flex"
                  outlined
                  :useBtnList="[
                      'btnRetrieve', //Retrieve
                      'btnExcel'   //Save Excel
                    ]"
                  @btnRetrieve="btnRetrieve()"
                  @btnExcel="onExporting()"
                >
                  <template v-slot:body>
                    <v-row no-gutters class="center pa-2 pb-0">
                        <v-icon small color="blue">mdi-circle</v-icon>
                        <span class="pa-1 subTitle">Cutter : </span>
                          <v-col cols="2">
                            <v-select
                              v-model="cutMaker"
                              :items="cutMakerList"
                              return-object
                              item-value="code"
                              item-text="codeName"
                              outlined
                              dense
                              height="32"
                              @change="btnRetrieve()"
                            />
                          </v-col>
                        
                          <v-icon small color="blue">mdi-circle</v-icon>
                        <span class="pa-2 pr-0"> Period : </span>
                          <v-col cols="1">
                              <DxDateBox :value="stDate" 
                              height="30px" 
                              display-format="yyyy-MM-dd" 
                              :acceptCustomValue="false" 
                              @value-changed="e => {stDate = e.value && getStrFormat(e.value)}" />
                          </v-col>
                          <span class="pa-2"> ~ </span>
                          <v-col cols="1" class="pl-0">
                              <DxDateBox :value="edDate" 
                              height="30px" 
                              display-format="yyyy-MM-dd" 
                              :acceptCustomValue="false" 
                              @value-changed="e => {edDate = e.value && getStrFormat(e.value)}" />
                          </v-col>
                        
                        <v-icon small color="blue">mdi-circle</v-icon>
                        <span class="pa-1 subTitle">Ship No. : </span>
                          <v-col cols="1">
                              <v-select
                                v-model="shipNo"
                                :items="shipNoList"
                                item-value="shipNo"
                                return-object
                                single-line
                                outlined
                                dense
                                label="Select"
                                @change="getBlock()"
                              ></v-select>
                          </v-col>
                        <span class="pa-1 subTitle">Block : </span>
                          <v-col cols="1">
                            <v-select
                              v-model="block"
                              :items="blockList"
                              single-line
                              outlined
                              dense
                              height="32"
                              @change="getCutGrp()"
                            />
                          </v-col>

                        <span class="pa-1 subTitle">Cut Group : </span>
                          <v-col cols="1">
                            <v-select
                              v-model="cutGrp"
                              :items="cutGrpList"
                              single-line
                              outlined
                              dense
                              height="32"
                              @change="btnRetrieve()"
                            />
                          </v-col>
                    </v-row>
                  </template>
                </i-card-top>
              </v-col>
            </v-row>
            
            <v-row no-gutters>
                <v-col cols="12" class="pt-1">
                  <DxDataGrid id="epmsa250" 
                    class="listBox" 
                    :ref="epmsa250Ref"
                    :data-source="gridMainList" 
                    :remote-operations="false" 
                    :hover-state-enabled="true"
                    :allow-column-resizing="true" 
                    :allow-column-reordering="true"
                    :row-alternation-enabled="true" 
                    :show-borders="true" 
                    :width="grid.width"
                    :show-row-lines="true" 
                    key-expr="id" 
                    :focused-row-enabled="true"
                    :column-hiding-enabled="false" 
                    :selection="{ mode: 'none' }"
                    :sorting="{ mode: 'none' }"
                    @exporting="onExporting"                                    
                                        
                                        
                  >
                    <DxPaging :enabled="false" />
                    <DxPager :visible="false" />
                    <DxExport :enabled="true" />
<!-- 
                    <TextBlock Text="STEEL CUTTING SCRAP STATUS"
                                Background="Red"
                                Foreground="White"
                                FontSize="20"
                                FontWeight="SemiBold"
                                TextAlignment="Center"
                                DockPanel.Dock="Top" />

                    <TextBlock Text="Cutting period: "
                                Background="Red"
                                Foreground="White"
                                FontSize="12"
                                FontWeight="SemiBold"
                                TextAlignment="Center"
                                DockPanel.Dock="Top" /> -->

                    <DxEditing :use-icons="true" mode="cell" />
                    <DxColumn data-field="rnum" caption="No" width="3%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn caption="Drawing Infor." alignment="center" :allow-editing="false" >
                      <DxColumn data-field="useShipNo" caption="Ship" width="5%" data-type="string" alignment="center" :allow-editing="false"/>
                      <DxColumn data-field="useLotNo" caption="Lot" width="5%" data-type="string" alignment="center" :allow-editing="false"/>
                      <DxColumn data-field="useCutGrp" caption="Group" width="5%" data-type="string" alignment="center" :allow-editing="false"/>
                      <DxColumn data-field="useDwgPage" caption="D.Page" width="5%" data-type="string" alignment="center" :allow-editing="false"/>
                      <DxColumn data-field="nestNo" caption="Nest No" width="7%" data-type="string" alignment="center" :allow-editing="false"/>
                    </DxColumn>
                    
                    <DxColumn caption="Steel specification" alignment="center" :allow-editing="false" >
                        <DxColumn data-field="markNo" caption="Mark No." width="7%" data-type="string" alignment="center" :allow-editing="false"/>
                        <DxColumn data-field="shape" caption="Shape" width="5%" data-type="string" alignment="center" :allow-editing="false"/>
                        <DxColumn data-field="grade" caption="Grade" width="5%" data-type="string" alignment="center" :allow-editing="false"/>
                        <DxColumn data-field="sizes" caption="Size" width="10%" data-type="string" alignment="center" :allow-editing="false"/>
                        <DxColumn data-field="length" caption="Length" width="5%" alignment="right" :allow-editing="false" data-type="number" format="#,###"/>
                    </DxColumn>

                    <DxColumn caption="Work order Infor." alignment="center" :allow-editing="false" >
                        <DxColumn data-field="woNo" caption="W/O No." width="8%" data-type="string" alignment="center" :allow-editing="false"/>
                        <DxColumn data-field="woQty" caption="Q'ty" width="5%" alignment="right" :allow-editing="false"  data-type="number" format="#,###"/>
                        <DxColumn data-field="woWgt" caption="Weight" width="7%" alignment="right" :allow-editing="false" data-type="number" format="#,###.0"/>
                    </DxColumn>

                    <DxColumn caption="Cutting Infor." alignment="center" :allow-editing="false" >
                        <DxColumn data-field="pcsNo" caption="PCS No." width="8%" data-type="string" alignment="center" :allow-editing="false"/>
                        <DxColumn data-field="cutQty" caption="Q'ty" width="5%" alignment="right" :allow-editing="false" data-type="number" format="#,###"/>
                        <DxColumn data-field="cutWgt" caption="Weight" width="7%" alignment="right" :allow-editing="false" data-type="number" format="#,###.0"/>
                        <DxColumn data-field="cutDte" caption="Cut Date" width="8%" data-type="string" alignment="center" :allow-editing="false"/>
                    </DxColumn>

                  
                    <DxColumn data-field="rmWgt" caption="Remain" width="5%" alignment="right" header-cell-template="rmWgtTemp" :allow-editing="false" data-type="number" format="#,##0.0"/>
                    <template #rmWgtTemp>
                      <div> Remained <br> Weight</div>
                    </template>
                    
                    <DxColumn data-field="rankPage" caption="Rank" width="5%" alignment="right" :allow-editing="false" data-type="number" format="#,###"/>
                    <DxColumn data-field="woCnt"  caption="Count" width="7%" alignment="right" header-cell-template="woCntTemp" :allow-editing="false" data-type="number" format="#,###"/>
                    <template #woCntTemp>
                      <div> W/O <br> per Lot</div>
                    </template>

                    <DxSummary :calculate-custom-summary="calculateCustomSummary">
                      <DxTotalItem column="useShipNo" summary-type="count" display-format="TOTAL" />
                      <DxTotalItem name="sumWoQty" summary-type="custom" show-in-column="woQty"/>
                      <DxTotalItem name="sumWoWgt" summary-type="custom"  show-in-column="woWgt"/>
                      <DxTotalItem column="cutQty" summary-type="sum" :customize-text="totalFormat" />
                      <DxTotalItem column="cutWgt" summary-type="sum" :customize-text="totalFormat" />
                      <DxTotalItem column="rmWgt" summary-type="sum" :customize-text="totalFormat" />
                    </DxSummary>
                  </DxDataGrid>
                </v-col>
            </v-row>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
    DxDataGrid,
    DxEditing,
    DxColumn,
    DxLookup,
    DxSelection,
    DxExport,
    DxPager
} from 'devextreme-vue/data-grid'
import baseview from '@/components/base/baseview.vue'
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import DxDateBox from 'devextreme-vue/date-box'
import { epmsa250, epmsa250Xls, epmsa250CutGrp } from '@/api/view/hip/A/epmsa250'
import { getCutMakerList, getBlockList } from '@/api/view/hip/A/epmsa240' 
import { getShipNoList} from '@/api/view/hip/A/epmsa010_kl'
import { getNumComma, toNum } from '@/utils/common.js'
import { getDateFormat, getCurrentDate } from '@/utils/common.js'
import dayjs from 'dayjs';
import { getCmChildCode } from '@/api/system/cmCodeManage'
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
// import { reportView } from '@/api/view/hip/common/common'

export default {
  name: 'epmsa250',
  mixins: [baseview, BaseDataGrid],
  components: {
    ICardVertical,
        'i-card-top': iCardTop,
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxDateBox,
    DxLookup,
    DxSelection,
    DxExport,
    DxPager
},

  data() {
    return {
      menuTitle: this.$route.meta.title,
      useBtnList: ['btnRetrieve' ,'btnExcel'],
      epmsa250Ref: 'epmsa250Ref',
      gridMainList: [],
      shipNoList: [],
      makerCd: this.$store.state.user.makerCd,
      shipNo: '',
      block: '',
      blockList: [],
      cutMaker: '',
      cutMakerList: [],
      stDate: null,
      edDate: null,
      cutGrp: '',
      cutGrpList: [],
      format: '#,##0.#',
    }
  },
  computed: {
    gridInstance() {
      return this.GetDataGrid(this.epmsa250Ref)
    },
  },
  mounted() {
    this.init()
    //this.gridMainInstance.option('defaultPaging', false)
    //this.getList() 
    //this.btnRetrieve()
  },
  methods: {
    calculateCustomSummary(options){
      if (options.name === 'sumWoQty') {
        if (options.summaryProcess === 'start') {
          options.totalValue = 0;
        }   

        if (options.summaryProcess === 'calculate' && (options.value.rankPage === '1' || options.value.woCnt >> '1')) {
          options.totalValue += Number(options.value.woQty);
        }

        if (options.summaryProcess === 'finalize' ) {
           options.totalValue = getNumComma(options.totalValue.toFixed(1));
        }
      }

      if (options.name === 'sumWoWgt') {
        if (options.summaryProcess === 'start') {
          options.totalValue = 0;
        }   

        if (options.summaryProcess === 'calculate' && (options.value.rankPage === '1' || options.value.woCnt >> '1')) {
          options.totalValue += Number(options.value.woWgt);
        }

        if (options.summaryProcess === 'finalize' ) {
          options.totalValue = getNumComma(options.totalValue.toFixed(1));
        }
      }

    },
    totalFormat(e) {
        const result = getNumComma(Number(e.value.toFixed(1)))
        return result
    },
    getStrFormat(date) {
        return getDateFormat(date)
    },
    init() {
        this.gridInstance.option('defaultPaging', false)
        let toDay = new Date
        this.stDate = toDay.setDate(toDay.getDate() - 7);
        //console.log(this.stDate) ;

        toDay = new Date
        this.edDate = toDay.setDate(toDay.getDate());

        this.stDate = dayjs(this.stDate).format('YYYY-MM-DD')
        this.edDate = dayjs(this.edDate).format('YYYY-MM-DD')

        this.getList()
    },
    async getList(){
      try {
        this.openLoading('searching')
        let params = {
          code: '',
          codegr: '',
          prtCode: 'CUT_RPT_DIV',
          userFlag: 'Y'
        }
        await getCmChildCode(params).then(res => {
          this.rptDivList = res.list
          this.rptDiv     = res.list[0]
        })

        let param = {
          makerCd: this.$store.state.user.makerCd
        }
        await getShipNoList(param).then(res => {
          this.shipNoList.push('')
          res.list.forEach(e => {
            this.shipNoList.push(e.shipNo)
          });
          this.shipNo = this.shipNoList[0] ;

        })
        await getCutMakerList(param).then(res => {
          this.cutMakerList.push({code: '' , codeName: ''})
          res.list.forEach(e => {
            e.code = e.cutMakerId
            e.codeName = !e.cutMakerNm ? '' : e.cutMakerNm 
            this.cutMakerList.push(e)
        });

          if(this.makerCd ==='11951') {
            this.cutMaker = this.cutMakerList[1];
          }else {
            this.cutMaker = this.cutMakerList[2];
          } ;
        
        })

      } finally {
      this.endLoading()
      }
    },
    async getBlock(){
      let param = {
        shipNo: this.shipNo
      }
      this.openLoading('searching')
      await getBlockList(param).then(res => {
        this.blockList = []
        this.blockList.push('')
        res.list.forEach(e => {
          this.blockList.push(e.block)
        });
        this.block = this.blockList[0]
      }).finally(() => {
        this.endLoading()
      })
    },
    
    async getCutGrp(){
      this.cutGrpList = []
      let param = {        
        shipNo: this.shipNo == 'Select' ? '' : this.shipNo,
        block: this.block
      }
      await epmsa250CutGrp(param).then(res => {
        this.cutGrpList.push('')
        res.list.forEach(e => {
          this.cutGrpList.push(e.useCutGrp)
        });
        this.cutGrp = this.cutGrpList[0]
      })
    },

    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('Steel Cutting Scrap Status');

      exportDataGrid({
        component: this.gridInstance,
        worksheet,
        topLeftCell: { row: 1, column: 1 },
      }).then((cellRange) => {
        const headerRow = worksheet.getRow(1);
        const headerStyle = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'DFE3D5' } }
        const headerBorderStyle = { left: { style: 'thin', fgColor: { argb: 'bfbfbf' } } , right: { style: 'thin', fgColor: { argb: 'bfbfbf' } }, bottom: {style: 'thin', fgColor: { argb: 'bfbfbf' }} }
        let headerRowLength = headerRow._cells.length
        for(let i = 1; i <= headerRowLength; i++){
          headerRow.getCell(i).fill = headerStyle
          headerRow.getCell(i).border = headerBorderStyle
          headerRow.getCell(i).alignment = { horizontal: 'center' }
        }
        for(let j = 2; j <= worksheet._rows.length; j++){
          for(let a = 1; a <= worksheet.getRow(j)._cells.length; a++){
            worksheet.getRow(j).getCell(a).border = headerBorderStyle
          }
        }
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'CuttingScrap.xlsx');
        });
      });
      this.gridInstance.cancel = true;
    },  

    async getMainList(){
      this.gridMainList = []
      try {
        this.openLoading('searching')
        let params = {
          shipNo : this.shipNo,
          block: this.block,
          cutGrp: this.cutGrp,
          cutMakerId: this.cutMaker.code,
          stDte: this.stDate,
          edDte: this.edDate
        }
        console.log(params)
        await epmsa250(params).then(res => {
          let list = []
          let cnt = 1;
          res.list.forEach(e => {
            if(e.rankPage > '1') {

             if(e.woCnt === '1') {
              list.push(
              {
                id: cnt++ , rnum: e.rnum,  useShipNo: null, useLotNo : null, useCutGrp: null, useDwgPage: null, nestNo: null,
                markNo: null,  shape: null, grade : null, sizes: null, length: null, 
                woNo: null, woQty: null, woWgt: null,
                pcsNo: e.pcsNo,  cutQty: e.cutQty, cutWgt : e.cutWgt, cutDte: e.cutDte, rmWgt: e.rmWgt, rankPage: e.rankPage, woCnt: e.woCnt
              })

             }else{
                list.push(
                {
                  id: cnt++ , rnum: e.rnum,  useShipNo: null, useLotNo : null, useCutGrp: null, useDwgPage: null, nestNo: null,
                  markNo: null,  shape: null, grade : null, sizes: null, length: null, 
                  woNo: e.woNo, woQty: e.woQty, woWgt: e.woWgt,
                  pcsNo: e.pcsNo,  cutQty: e.cutQty, cutWgt : e.cutWgt, cutDte: e.cutDte, rmWgt: e.rmWgt, rankPage: e.rankPage, woCnt: e.woCnt
                })
             }
              
            }
            else {
              list.push(
              {
                id: cnt++ , rnum: e.rnum,  useShipNo: e.useShipNo, useLotNo : e.useLotNo, useCutGrp: e.useCutGrp, useDwgPage: e.useDwgPage, nestNo: e.nestNo,
                markNo: e.markNo,  shape: e.shape, grade : e.grade, sizes: e.sizes, length: e.length, 
                woNo: e.woNo, woQty: e.woQty, woWgt: e.woWgt,
                pcsNo: e.pcsNo,  cutQty: e.cutQty, cutWgt : e.cutWgt, cutDte: e.cutDte, rmWgt: e.rmWgt, rankPage: e.rankPage, woCnt: e.woCnt
              })
            }
          });
          console.log(list)
          this.gridMainList = list
        })
      } finally {
      this.endLoading()
      }
    },
    btnRetrieve(){
      this.gridMainList = []
      this.getMainList()
    },
    btnExcel(){
      this.openLoading('searching')
      const param = {
        shipNo : this.shipNo,
          block: this.block,
          cutGrp: this.cutGrp,
          cutMakerId: this.cutMaker.code,
          stDte: this.stDate,
          edDte: this.edDate
      }
      epmsa250Xls(param)
      this.endLoading()
    },
    cellPrepared(e){
      if (e.rowType === 'data') {          
        if (e.column.dataField == 'useShipNo' || e.column.dataField == 'useLotNo' || e.column.dataField == 'useCutGrp' || e.column.dataField == 'useDwgPage'  ) {
          e.cellElement.style['vertical-align'] = 'top'
          if (this.curRowIndex + 1 !== this.gridMainList.length) {
            if (e.rowIndex > 0 & e.value.rankPage >> '1') {
                e.cellElement.style.display = 'none'
            }
          }
        }
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.epmsa250-main {
  .subTitle {
    font-weight: bold;
    color: black;
  }
}
</style>